import { Row, Col, Button, Card, FormLabel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { KTSVG } from "../../../_uLearn/helpers";
import { SchoolString, vendorString } from "../../../utils/string";
import threeDotRound from "../../../_uLearn/assets/media/svg_uLearn/three-dot.svg";
import { useEffect, useState } from "react";
import { CustomSelectWhite } from "../../custom/Select/CustomSelectWhite";
import { CustomSelectTable } from "../../custom/Select/CustomSelectTable";
import { PAGE_LIMIT } from "../../../utils/constants";
import APICallService from "../../../api/apiCallService";
import { VENDORS } from "../../../api/apiEndPoints";
import Pagination from "../../../Global/pagination";
import { success } from "../../../Global/toast";
import { VendorToast } from "../../../utils/toast";
import RemoveModal from "../../modals/remove-modal";
import Loader from "../../../Global/loader";
import { useDebounce } from "../../../utils/useDebounce";
import { vendorJSON } from "../../../api/apiJSON/vendor";
import { CustomComponentSelect } from "../../custom/Select/CustomComponentSelect";
import UnCheck from "../../../_uLearn/assets/media/svg_uLearn/uncheck.svg";
import Check from "../../../_uLearn/assets/media/svg_uLearn/check.svg";
import { getKey, removeKey, setKey } from "../../../Global/history";
import { listVendors } from "../../../utils/storeString";
const Vendors = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState<any>(getKey(listVendors.page) || 1);
  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listVendors.limit) || PAGE_LIMIT
  );
  const [vendorData, setVendorData] = useState<any>({});
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);
  const [id, setId] = useState(-1);
  const [searchTerm, setSearchTerm] = useState<string>(
    getKey(listVendors.search)?.toString() || ""
  );
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [subCategoryDetails, setSubCategoryDetails] = useState([]);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(
    getKey(listVendors.filterByCategory) || ""
  );
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(
    getKey(listVendors.filterBySubCategory) || []
  );
  const handleClose = () => {
    setShowRemoveModal(false);
  };
  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchVendor(
        page,
        pageLimit,
        searchTerm,
        selectedCategory,
        selectedSubCategory
      );
      await fetchCategoryDetails();
      setLoading(false);
      setTimeout(() => {
        const pos = getKey(listVendors.scrollPosition);
        window.scrollTo(0, pos);
      }, 500);
    })();
  }, []);
  const handleAddVendor = () => {
    navigate("./add-vendor");
  };
  const fetchVendor = async (
    pageNo: number,
    limit: number,
    search?: string,
    category?: any,
    selectedSubCategory?: any
  ) => {
    setLoading(true);
    let params = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "_createdAt",
      sortOrder: -1,
      searchTerm: search?.trim() || "",
      category: category && category.value.length > 0 ? category.value : "",
      selectedSubCategory: selectedSubCategory,
    };
    let apiService = new APICallService(
      VENDORS.GET_VENDOR_LIST,
      vendorJSON.listVendor(params)
    );
    let response = await apiService.callAPI();

    if (response) {
      if (response.total) {
        setTotalRecords(response.total);
      } else {
        // let prevTotal = totalRecords;
        setTotalRecords(0);
      }
      setVendorData(response.records);
    }
    setLoading(false);
  };

  const fetchCategoryDetails = async () => {
    setLoading(true);
    let apiService = new APICallService(VENDORS.GET_CATEGORY_LIST);
    let response: any = await apiService.callAPI();
    if (response) {
      setCategoryDetails(response.records);
      const id = getKey(listVendors.filterByCategory);
      if (id) {
        const temp = response.records.find((item: any) => item._id == id._id);
        let subCategoryTemp = temp?.subCategory?.map((val: any) => {
          return {
            id: val._id,
            name: val.name,
            value: val._id,
            label: (
              <>
                <span className="fs-16 fw-600 text-black ">{val.name}</span>
              </>
            ),
          };
        });
        setSubCategoryDetails(subCategoryTemp);
      }
    }
    setLoading(false);
  };

  const handleDelete = async (_id: string) => {
    const apiService = new APICallService(VENDORS.DELETE_VENDOR, _id);
    const response = await apiService.callAPI();
    if (response) {
      success(VendorToast.delete);
      setShowRemoveModal(false);
      setKey(listVendors.page, 1);
      setPage(1);
      await fetchVendor(1, pageLimit);
    }
  };
  const handleCurrentPage = async (val: number) => {
    if (val === page || val.toString() === "...") return;
    setPage(val);
    setKey(listVendors.page, val);
    await fetchVendor(
      val,
      pageLimit,
      searchTerm,
      selectedCategory,
      selectedSubCategory
    );
  };
  const handleNextPage = async (val: number) => {
    setPage(val + 1);
    setKey(listVendors.page, val + 1);
    await fetchVendor(
      val + 1,
      pageLimit,
      searchTerm,
      selectedCategory,
      selectedSubCategory
    );
  };
  const handlePreviousPage = async (val: number) => {
    setPage(val - 1);
    setKey(listVendors.page, val - 1);
    await fetchVendor(
      val - 1,
      pageLimit,
      searchTerm,
      selectedCategory,
      selectedSubCategory
    );
  };
  const handlePageLimit = async (event: any) => {
    setPage(1);
    await setPageLimit(parseInt(event.target.value));
    setKey(listVendors.page, 1);
    setKey(listVendors.limit, parseInt(event.target.value));
    await fetchVendor(
      1,
      event.target.value,
      searchTerm,
      selectedCategory,
      selectedSubCategory
    );
  };
  const handleCategoryChange = async (event: any) => {
    setKey(listVendors.page, 1);
    setSelectedSubCategory([]);
    await fetchVendor(1, pageLimit, searchTerm, event, []);
    setSelectedCategory(event);
    setKey(listVendors.filterByCategory, event);
    setPage(1);
    let subCategoryTemp = event?.subCategory?.map((val: any) => {
      return {
        id: val._id,
        name: val.name,
        value: val._id,
        label: (
          <>
            <span className="fs-16 fw-600 text-black ">{val.name}</span>
          </>
        ),
      };
    });
    setSubCategoryDetails(subCategoryTemp);
    if (event == null) {
      removeKey(listVendors.filterBySubCategory);
    }
  };

  const handleSubcategoryChange = async (event: any) => {
    setKey(listVendors.filterBySubCategory, event);
    setPage(1);
    await fetchVendor(1, pageLimit, searchTerm, selectedCategory, event);
    setSelectedSubCategory(event);
  };
  const openMenuOnClick = async (data: any) => {
    setId(id);
    setShow(true);
  };
  const onMenuClose = async () => {
    setId(-1);
    setShow(false);
  };
  const onMenuOpen = async (id: any) => {
    setId(id);
    setShow(true);
  };
  const handleOption = async (event: any, index: number, data: any) => {
    if (event.value === 1) {
      setKey(listVendors.scrollPosition, window.scrollY.toString());
      navigate("edit-vendor", { state: data });
      setData(data);
    }
    if (event.value === 2) {
      setData(data);
      setShowRemoveModal(true);
    }
  };
  const debounce = useDebounce(fetchVendor, 400);
  const handleSearchTerm = async (value: string) => {
    value = value.trimStart();
    //const regex = /^(\w+( \w+)*)( {0,1})$/;
    //const regex = /^(\w+( \w+)*)? ?$/;
    const regex = /^(\S+( \S+)*)? ?$/;
    const isValid = regex.test(value);
    if (!isValid) {
      return;
    }
    setSearchTerm(value);
    setKey(listVendors.page, 1);
    if (value.trim().length > 2 && searchTerm !== value) {
      setPage(1);
      setLoading(true);
      setTotalRecords(0);
      await debounce(
        1,
        pageLimit,
        value,
        selectedCategory,
        selectedSubCategory
      );
      setLoading(false);
    } else if (value.trim().length <= 2 && value.length < searchTerm.length) {
      setPage(1);
      setLoading(true);
      setTotalRecords(0);
      await debounce(
        1,
        pageLimit,
        value,
        selectedCategory,
        selectedSubCategory
      );
      setLoading(false);
    }
    setKey(listVendors.search, value);
  };
  const handleCheckboxChange = async (
    event: any,
    services: any,
    index: number
  ) => {
    const isChecked = event.target.checked;
    let apiService = new APICallService(
      VENDORS.updateStatus,
      vendorJSON.updateStatus(isChecked),
      { id: services._id }
    );
    let response = await apiService.callAPI();
    if (response) {
      const temp = [...vendorData];
      temp[index].isActive = isChecked;
      setVendorData(temp);
      isChecked
        ? success(VendorToast.activate)
        : success(VendorToast.deactivate);
    }
  };
  const handleApprovedChange = async (services: any, index: number) => {
    const Checked: any = services.isApproved == false && true;
    let apiService = new APICallService(
      VENDORS.updateApproval,
      vendorJSON.updateApproval(Checked),
      { id: services._id }
    );
    let response = await apiService.callAPI();
    if (response) {
      const temp = [...vendorData];
      temp[index].isApproved = Checked;
      setVendorData(temp);
      Checked && success(VendorToast.isApproval);
    }
  };
  const handleVendorProfile = (teacherVal: string) => {
    setKey(listVendors.scrollPosition, window.scrollY.toString());
    navigate("/vendors/view-vendor", { state: teacherVal });
  };
  return (
    <>
      {data && showRemoveModal && (
        <RemoveModal
          show={showRemoveModal}
          handleClose={handleClose}
          onHide={handleClose}
          editData={data}
          title="Vendor"
          handleDelete={handleDelete}
        />
      )}
      <Row className="align-items-center g-md-5 g-3 mb-7">
        <Col
          sm
          // className="mb-6"
        >
          <h1 className="fs-22 fw-bolder">{vendorString.Title}</h1>
        </Col>
        {loading ? (
          <></>
        ) : (
          <Col xs="auto">
            <Button
              variant="primary"
              className="fs-16 fw-bold btn-lg"
              onClick={() => handleAddVendor()}
            >
              {vendorString.AddButton}
            </Button>
          </Col>
        )}
        <Col xs={12}>
          <Card className="bg-light border mb-7">
            <Card.Body className="px-7">
              <Row className="align-items-center g-5">
                <Col md={6} lg={4}>
                  <FormLabel className="fs-16 fw-500 text-dark">
                    {vendorString.Filterbykeyword}
                  </FormLabel>
                  <div className="d-flex align-items-center position-relative me-lg-4">
                    <KTSVG
                      path="/media/icons/duotune/general/gen021.svg"
                      className="svg-icon-3 position-absolute ms-3"
                    />
                    <input
                      type="text"
                      id="kt_filter_search"
                      className="form-control form-control-white min-h-60px form-control-lg ps-10"
                      placeholder="Search by vendor and business name…"
                      onChange={(e) => handleSearchTerm(e.target.value)}
                      value={searchTerm}
                      // onKeyUp={(e) => handleOnKeyUp(e)}
                    />
                  </div>
                </Col>
                <Col md={6} lg={4}>
                  <FormLabel className="fs-16 fw-500 text-dark">
                    {vendorString.Filterbycategory}
                  </FormLabel>
                  <CustomSelectWhite
                    options={
                      categoryDetails?.length
                        ? categoryDetails?.map((val: any) => {
                            return {
                              value: val._id,
                              label: val.name,
                              _id: val._id,
                              subCategory: val.subCategory,
                            };
                          })
                        : []
                    }
                    onChange={(event: any) => {
                      handleCategoryChange(event);
                    }}
                    isClearable={true}
                    // isDisabled={loading}
                    hideSelectedOptions={false}
                    // options={classSelectJSON}
                    // onChange={(event: any) => {
                    //   handleCategoryFilter(event);
                    // }}
                    isMulti={false}
                    value={
                      selectedCategory &&
                      categoryDetails
                        ?.map((val: any) => {
                          return {
                            value: val._id,
                            label: val.name,
                            _id: val._id,
                            subCategory: val.subCategory,
                          };
                        })
                        .find((item: any) => item?._id == selectedCategory?._id)
                    }
                  />
                </Col>
                {!!subCategoryDetails?.length && (
                  <Col md={6} lg={4}>
                    <FormLabel className="fs-16 fw-500 text-dark">
                      {vendorString.FilterbySubCategory}
                    </FormLabel>
                    <CustomComponentSelect
                      isLoading={loading}
                      options={
                        subCategoryDetails?.length
                          ? subCategoryDetails?.map((val: any) => {
                              return {
                                value: val.value,
                                label: val.name,
                                _id: val.id,
                                id: val.id,
                                name: val.name,
                                title: val.name,
                              };
                            })
                          : []
                      }
                      onChange={(event: any) => {
                        handleSubcategoryChange(event);
                      }}
                      value={selectedSubCategory}
                      // value={
                      //   selectedSubject?.length
                      //     ? selectedSubject.map((val: any) => {
                      //         return {
                      //           value: val._id,
                      //           label: val.label,
                      //           _id: val._id,
                      //           id: val._id,
                      //           name: val.name,
                      //           title: val.name,
                      //         };
                      //       })
                      //     : null
                      // }
                      isMulti={true}
                      hideSelectedOptions={false}
                      // options={productStatusJSON}
                      // isClearable={Object.keys(productState).length}
                    />
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={12}>
          <Card className="border border-r10px">
            <Card.Body className="p-0">
              <div className="table-responsive">
                <table className="table table-rounded table-row-bordered align-middle gs-7 gy-4 mb-0">
                  <thead>
                    <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-70px align-middle gy-3">
                      <th className="min-w-325px">
                        {vendorString.VendorsDetails}
                      </th>
                      <th className="min-w-200px text-center">
                        {vendorString.BusinessName}
                      </th>
                      <th className="min-w-200px text-center">
                        {vendorString.PhoneNumber}
                      </th>
                      <th className="min-w-200px text-center">
                        {vendorString.Category}
                      </th>
                      <th className="min-w-100px text-center">
                        {vendorString.Leads}
                      </th>
                      <th className="min-w-100px text-center">
                        {vendorString.Viewers}
                      </th>
                      <th className="min-w-200px text-end"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <>
                        <td colSpan={5}>
                          <div className="w-100 d-flex justify-content-center">
                            <Loader loading={loading} />
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        {vendorData?.length ? (
                          <>
                            {vendorData.map(
                              (schoolVal: any, schoolIndex: number) => {
                                return (
                                  <tr>
                                    <td>
                                      <div className="d-flex align-items-center flex-row">
                                        {schoolVal?.image && (
                                          <div className="symbol symbol-50px border">
                                            <img
                                              className="img-fluid border-r8px object-fit-contain"
                                              src={schoolVal?.image}
                                              alt=""
                                            />
                                          </div>
                                        )}
                                        <span className="fs-15 fw-600 ms-3">
                                          {schoolVal?.name || "-"}
                                          <br />
                                          <span className="text-muted fw-semibold text-muted d-block fs-7">
                                            {schoolVal?.email}
                                          </span>
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{ maxWidth: "150px" }}
                                    >
                                      <span className="fs-15 fw-600">
                                        {schoolVal?.businessName || "-"}
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      <span className="fs-15 fw-600 ">
                                        {schoolVal?.phoneCountry +
                                          " " +
                                          schoolVal?.phone}
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      <span className="fs-15 fw-600">
                                        {schoolVal?.category?.name || "-"}
                                      </span>
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-center">
                                        <span className="badge bg-efefef border-r4px p-3 fs-15 fw-600 text-dark">
                                          {schoolVal?.leads || "-"}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-center">
                                        <span className="badge bg-efefef border-r4px p-3 fs-15 fw-600 text-dark">
                                          {schoolVal?.views || "-"}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-center flex-nowrap my-1  float-end">
                                        <label className="form-check form-switch form-check-custom form-check-solid ">
                                          <input
                                            className="form-check-input form-check-success w-50px h-30px "
                                            type="checkbox"
                                            name="notifications"
                                            checked={schoolVal?.isActive}
                                            onChange={(event) =>
                                              handleCheckboxChange(
                                                event,
                                                schoolVal,
                                                schoolIndex
                                              )
                                            }
                                            title={
                                              schoolVal.isActive
                                                ? "Deactivate Vendor"
                                                : "Activate Vendor"
                                            }
                                          />
                                        </label>
                                        <div className="symbol symbol-40px">
                                          <Button
                                            variant=""
                                            onClick={() => {
                                              handleApprovedChange(
                                                schoolVal,
                                                schoolIndex
                                              );
                                            }}
                                            disabled={
                                              schoolVal?.isApproved == true
                                            }
                                            title={
                                              schoolVal?.isApproved
                                                ? "Already Approved"
                                                : "Approve Vendor"
                                            }
                                          >
                                            <img
                                              src={
                                                schoolVal?.isApproved
                                                  ? Check
                                                  : UnCheck
                                              }
                                              alt=""
                                              height={35}
                                              width={35}
                                            />
                                          </Button>
                                        </div>
                                        <button
                                          className="btn btn-primary btn-sm px-4 fs-6"
                                          style={{ whiteSpace: "nowrap" }}
                                          onClick={() => {
                                            handleVendorProfile(schoolVal);
                                          }}
                                        >
                                          {vendorString.view}
                                        </button>
                                        <CustomSelectTable
                                          marginLeft={"-110px"}
                                          width={"auto"}
                                          placeholder={
                                            <img
                                              className=""
                                              width={22}
                                              height={6}
                                              src={threeDotRound}
                                              alt=""
                                            />
                                          }
                                          options={[
                                            {
                                              label: (
                                                <button className="btn btn-link fs-14 fw-600 text-black ms-3 p-4">
                                                  {vendorString.edit}
                                                </button>
                                              ),
                                              value: 1,
                                            },
                                            {
                                              label: (
                                                <button className="btn btn-link fs-14 fw-600 text-danger ms-3 p-4  ">
                                                  {vendorString.delete}
                                                </button>
                                              ),
                                              value: 2,
                                            },
                                          ]}
                                          backgroundColor="white"
                                          show={show && schoolIndex === id}
                                          onMenuClose={() => {
                                            onMenuClose();
                                          }}
                                          openMenuOnClick={() => {
                                            openMenuOnClick(schoolIndex);
                                          }}
                                          onMenuOpen={() => {
                                            onMenuOpen(schoolIndex);
                                          }}
                                          onChange={(event: any) => {
                                            handleOption(
                                              event,
                                              schoolIndex,
                                              schoolVal
                                            );
                                          }}
                                          // isOptionDisabled={(option: any) => option.value === 2}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={8}>
                              <div className="w-100 fs-15 fw-bold d-flex justify-content-center">
                                {SchoolString.noData}
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
          {!loading && totalRecords > 0 ? (
            <Pagination
              totalRecords={totalRecords}
              currentPage={page}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              handlePageLimit={handlePageLimit}
              pageLimit={pageLimit}
            />
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </>
  );
};
export default Vendors;
